import React, { useEffect, useState } from "react";
import { saasApi } from "../../api/saasApi";

export default function TrialDashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    saasApi.adminAnalyticsTrials().then((res) => setData(res.data));
  }, []);

  if (!data) return <p>Loading…</p>;

  return (
    <div>
      <h1>Trial dashboard</h1>
      <div className="saas-stats">
        <div className="saas-stat"><span>Active trials</span><strong>{data.trialing}</strong></div>
        <div className="saas-stat"><span>Expiring in 7 days</span><strong>{data.expiring_within_7_days}</strong></div>
        <div className="saas-stat"><span>Trial started</span><strong>{data.trial_started}</strong></div>
        <div className="saas-stat"><span>Converted to paid</span><strong>{data.converted_to_paid}</strong></div>
        <div className="saas-stat"><span>Conversion rate</span><strong>{data.conversion_rate}%</strong></div>
      </div>
    </div>
  );
}
